import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export const RelatedPostsSlider = () => {
    return {
        init() {
            const swipers = document.querySelectorAll('.relatedPostSwiper');
            swipers.forEach((swiper) => {
                new Swiper(swiper, {
                    slidesPerView: 1.1,
                    grabCursor: true,
                    freeMode: true,
                    spaceBetween: 20,
                    breakpoints: {
                        761: {
                            slidesPerView: 2,
                        },
                        1200: {
                            slidesPerView: 3,
                            spaceBetween: 30,
                            freeMode: false,
                            grabCursor: false,
                        },
                    }
                });
            });
        }
    }
}